<template>
    <div>
        <div class="widget-title">
            {{ title }}
        </div>
        <div class="widget-amounts">
            <div class="current-amount">
                {{ amount | money }} {{ currency | currency }}
                <!-- {{ options.currency === 'uah' ? '₴' : '' }}
                {{ options.currency === 'eur' ? '€' : '' }}
                {{ options.currency === 'usd' ? '$' : '' }} -->
            </div>
            <!-- <div class="total-amount" v-if="budget_today !== 0">
                {{ budget_today | money }} ₴
            </div> -->
        </div>
        <!-- <div class="progress">
            <div class="progress-bar" :style="{width: `${budget_percent}%`}"></div>
        </div> -->
    </div>
</template>

<script>
export default {
    name: "WeekSpendsWidget",

    props: ['title', 'data'],

    computed: {
        amount() {
            return this.data.value ? this.data.value : 0
        },

        currency() {
            return this.data.currency ? this.data.currency : 0
        }
    }
}
</script>

<style lang="scss" scoped>

</style>